import React, { useEffect, useState } from 'react';
import Layout from '../../elements/Layout';
import { IoIosSearch } from 'react-icons/io';
import { MdOutlineFilterAlt } from 'react-icons/md';
import { fetchProjects } from '../../utils/api/api';
import toast from 'react-hot-toast';
import { CSVLink } from 'react-csv';
import { useNavigate } from 'react-router-dom';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [projectsPerPage] = useState(20);
  const navigate = useNavigate()

  const headers = [
    { label: "ID", key: "id" },
    { label: "Title", key: "title" },
    { label: "Description", key: "description" },
    { label: "Manager ID", key: "manager_id" },
    { label: "Manager First Name", key: "manager_first_name" },
    { label: "Manager Last Name", key: "manager_last_name" },
    { label: "Manager Phone Number", key: "manager_phone_number" },
    { label: "Manager Email", key: "manager_email" },
    { label: "Location", key: "location" },
    { label: "Start Date", key: "start_date" },
    { label: "End Date", key: "end_date" },
    { label: "Budget", key: "budget" },
    { label: "Status", key: "status" },
    { label: "Progress", key: "progress" },
    { label: "Created At", key: "createdAt" },
    { label: "Updated At", key: "updatedAt" },
  ];

  const flattenProjects = projects.map(project => ({
    id: project.id,
    title: project.title,
    description: project.description,
    manager_id: project.manager_id,
    manager_first_name: project.manager?.first_name || '',
    manager_last_name: project.manager?.last_name || '',
    manager_phone_number: project.manager?.phone_number || '',
    manager_email: project.manager?.email || '',
    location: project.location,
    start_date: project.start_date,
    end_date: project.end_date,
    budget: project.budget,
    status: project.status,
    progress: project.progress,
    createdAt: new Date(project.createdAt).toLocaleString(),
    updatedAt: new Date(project.updatedAt).toLocaleString(),
  }));

  const getProjects = async () => {
    setLoading(true);
    try {
      const data = await fetchProjects('housing');
      setProjects(data.projects);
      setLoading(false);
    } catch (err) {
      toast.error('Failed to fetch Projects.');
      setLoading(false);
    }
  };

  useEffect(() => {
    getProjects();
  }, []);

  const indexOfLastProject = currentPage * projectsPerPage;
  const indexOfFirstProject = indexOfLastProject - projectsPerPage;
  const currentProjects = projects.slice(indexOfFirstProject, indexOfLastProject);

  const totalPages = Math.ceil(projects.length / projectsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <Layout text={"Projects"}>
      <div className='w-full grid grid-cols-2 md:grid-cols-4 gap-4'>
        <div className="bg-white w-full rounded-lg p-4 flex flex-col gap-1.5">
          <p className="text-primary text-[13px]">Total Projects</p>
          <hr />
          <p className="text-primary text-[16px]">4378</p>
        </div>
        <div className="bg-white w-full rounded-lg p-4 flex flex-col gap-1.5">
          <p className="text-primary text-[13px]">In progress</p>
          <hr />
          <p className="text-primary text-[16px]">7854</p>
        </div>
        <div className="bg-white w-full rounded-lg p-4 flex flex-col gap-1.5">
          <p className="text-primary text-[13px]">On hold</p>
          <hr />
          <p className="text-primary text-[16px]">872</p>
        </div>
        <div className="bg-white w-full rounded-lg p-4 flex flex-col gap-1.5">
          <p className="text-primary flex items-center gap-2 text-[13px]">Complete <span className="hidden md:flex">Projects</span></p>
          <hr />
          <p className="text-primary text-[16px]">548</p>
        </div>
      </div>
      <div className="mt-4 flex gap-2 md:items-center flex-col md:flex-row bg-[#fff] p-2 rounded-md justify-between">
        <div className="w-full md:w-fit border border-gray-300 rounded-md bg-[#EBEBEB] text-[13px] py-2 px-2 riunded-md flex gap-2 items-center">
          <IoIosSearch className='text-gray-600' />
          <input type="text" placeholder='Search' className='bg-transparent h-full outline-none text-gray-600 w-[250px]' />
        </div>
        <div className="w-full md:w-fit justify-between flex items-center gap-2">
          <CSVLink
            data={flattenProjects}
            headers={headers}
            filename={"projects.csv"}
            className="bg-secondary flex rounded-md text-white text-[14px] font-medium px-4 py-1.5 items-center gap-2"
          >
            <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M6 8L5.95396 8C5.05849 7.99998 4.31952 7.99997 3.71983 8.05432C3.09615 8.11085 2.52564 8.23242 2 8.5359C1.39192 8.88697 0.886973 9.39192 0.535899 10C0.23242 10.5256 0.11085 11.0961 0.0543238 11.7198C-2.77768e-05 12.3195 -1.51045e-05 13.0585 2.5181e-07 13.9539L2.51811e-07 13.954L2.53821e-07 14L2.55836e-07 14.046L2.55837e-07 14.0461C-1.51045e-05 14.9415 -2.778e-05 15.6805 0.0543237 16.2802C0.11085 16.9039 0.232419 17.4744 0.535899 18C0.886973 18.6081 1.39192 19.113 2 19.4641C2.52564 19.7676 3.09615 19.8891 3.71983 19.9457C4.3195 20 5.05845 20 5.95387 20L5.95394 20L6 20L16 20L16.046 20L16.046 20C16.9415 20 17.6805 20 18.2802 19.9457C18.9039 19.8891 19.4744 19.7676 20 19.4641C20.6081 19.113 21.113 18.6081 21.4641 18C21.7676 17.4744 21.8892 16.9039 21.9457 16.2802C22 15.6805 22 14.9415 22 14.0461L22 14.046L22 14L22 13.954L22 13.9539C22 13.0585 22 12.3195 21.9457 11.7198C21.8892 11.0961 21.7676 10.5256 21.4641 10C21.113 9.39192 20.6081 8.88697 20 8.5359C19.4744 8.23242 18.9039 8.11085 18.2802 8.05432C17.6805 7.99997 16.9415 7.99998 16.046 8L16 8L15 8C14.4477 8 14 8.44771 14 9C14 9.55228 14.4477 10 15 10L16 10C16.953 10 17.6009 10.001 18.0996 10.0462C18.5846 10.0901 18.8295 10.1695 19 10.2679C19.304 10.4435 19.5565 10.696 19.7321 11C19.8305 11.1705 19.9099 11.4154 19.9538 11.9004C19.999 12.3991 20 13.047 20 14C20 14.953 19.999 15.6009 19.9538 16.0996C19.9099 16.5846 19.8305 16.8295 19.7321 17C19.5565 17.304 19.304 17.5565 19 17.7321C18.8295 17.8305 18.5846 17.9099 18.0996 17.9538C17.6009 17.999 16.953 18 16 18L6 18C5.04698 18 4.39908 17.999 3.90036 17.9538C3.41539 17.9099 3.17051 17.8305 3 17.732C2.69596 17.5565 2.44349 17.304 2.26795 17C2.16951 16.8295 2.09011 16.5846 2.04616 16.0996C2.00096 15.6009 2 14.953 2 14C2 13.047 2.00096 12.3991 2.04616 11.9004C2.09011 11.4154 2.16951 11.1705 2.26795 11C2.44349 10.696 2.69596 10.4435 3 10.2679C3.17051 10.1695 3.41539 10.0901 3.90036 10.0462C4.39908 10.001 5.04698 10 6 10L7 10C7.55229 10 8 9.55228 8 9C8 8.44771 7.55229 8 7 8L6 8ZM11.7071 0.292892C11.3166 -0.0976319 10.6834 -0.0976319 10.2929 0.292892L6.29289 4.29289C5.90237 4.68342 5.90237 5.31658 6.29289 5.70711C6.68342 6.09763 7.31658 6.09763 7.70711 5.70711L10 3.41421L10 14C10 14.5523 10.4477 15 11 15C11.5523 15 12 14.5523 12 14L12 3.41421L14.2929 5.70711C14.6834 6.09763 15.3166 6.09763 15.7071 5.7071C16.0976 5.31658 16.0976 4.68342 15.7071 4.29289L11.7071 0.292892Z" fill="white" />
            </svg>
            Export
          </CSVLink>
          <button className="px-4 py-1.5 flex items-center gap-2 text-[14px] text-secondary rounded-md border border-secondary">
            <MdOutlineFilterAlt size={18} />
            Filter
          </button>
          <button
            onClick={() => navigate('/dashboard/projects/new')}
            className="bg-secondary rounded-md font-medium text-white capitalize text-[14px] outline-none px-4 py-1.5 flex items-center gap-2"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            Add <span className="hidden md:block">Project</span>
          </button>
        </div>
      </div>

      <div className="w-full bg-white rounded-lg mt-4 p-4 ">
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white h-full flex-grow table-auto">
            <thead>
              <tr className="text-primary border-b pb-4 text-[14px] py-3 bg-[#F7F7F7] font-medium leading-normal">
                <th className="py-3 px-6 text-left w-1/5 whitespace-nowrap gap-2 flex">
                  Project Name
                </th>
                <th className="py-3 px-6 text-left w-1/5 whitespace-nowrap">Start Date</th>
                <th className="py-3 px-6 text-left w-1/5 whitespace-nowrap">End Date</th>
                <th className="py-3 px-6 text-left w-1/5 whitespace-nowrap">Price</th>
                <th className="py-3 px-6 text-left w-1/5 whitespace-nowrap">Location</th>
                <th className="py-3 px-6 text-left w-1/5 whitespace-nowrap">Assigned to</th>
                <th className="py-3 px-6 text-left w-1/5 whitespace-nowrap">Date Listed</th>
                <th className="py-3 px-6 text-left w-1/5 whitespace-nowrap">Status</th>
              </tr>
            </thead>
            <tbody className="text-primary text-[14px] font-light">
              {currentProjects.length === 0 ? (
                <tr>
                  <td colSpan="7" className="py-4 px-6 text-center text-gray-500">
                    {loading ? 'Loading, please wait' : 'No data found'}
                  </td>
                </tr>
              ) : (
                  currentProjects.map((project, index) => (
                  <tr
                    key={index}
                    onClick={() => window.location.assign(`/dashboard/projects/${project.id}/view`)}
                    className={`border-b text-black font-light text-[14px] border-gray-200 cursor-pointer hover:bg-gray-50 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                      }`}
                  >
                    <td className="py-4 px-6 text-left whitespace-nowrap">
                      <span>{project.title}</span>
                    </td>
                    <td className="py-4 px-6 text-left whitespace-nowrap">
                      <span>{project.start_date}</span>
                    </td>
                    <td className="py-4 px-6 text-left whitespace-nowrap">
                      <span>{project.end_date}</span>
                    </td>
                    <td className="py-4 px-6 text-left whitespace-nowrap">
                      <span>Kes {project.price.toLocaleString("KES")}</span>
                    </td>
                    <td className="py-4 px-6 text-left whitespace-nowrap">
                      <span>{project.location}</span>
                    </td>
                    <td className="py-4 px-6 text-left whitespace-nowrap">
                      <span>{project.manager.first_name} {project.manager.last_name}</span>
                    </td>
                    <td className="py-4 px-6 text-left whitespace-nowrap">
                      <span>{new Date(project.createdAt).toLocaleDateString()}</span>
                    </td>
                    <td className="py-4 px-6 text-left whitespace-nowrap">
                      <span
                        className={`${project.status === 'not_started' ? 'text-gray-500 bg-gray-100 py-1 px-2 rounded' :
                          project.status === 'in_progress' ? 'text-yellow-500 bg-yellow-100 p-1 px-2 rounded-full' :
                            project.status === 'planned' ? 'text-gray-500 bg-gray-300 p-1 px-2 rounded-full' :
                              project.status === 'completed' ? 'text-green-500 bg-green-100 py-1 px-2 rounded-full' :
                                project.status === 'on_hold' ? 'text-red-500 bg-red-100 py-1 px-2 rounded-full' : 'text-black bg-white'
                          }`}
                      >
                        {project.status.replace('_', ' ')}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        {currentProjects.length > 0 && (
          <div className="w-full flex justify-end -mt-2 ">
            <button
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              className="text-[14px] flex mr-1 items-center text-primary font-light gap-2"
            >
              Prev
            </button>
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i + 1}
                onClick={() => paginate(i + 1)}
                className={`px-3 py-1.5 mx-1 text-[14px] font-medium ${currentPage === i + 1 ? 'bg-primary text-white' : 'text-primary'} rounded-md`}
              >
                {i + 1}
              </button>
            ))}
            <button
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="text-[14px] flex ml-1 items-center text-primary font-light gap-2"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Projects;
